export const glossaryData = `<p>Key Terms that you will see referenced in this guide:</p>
<table class='table table-bordered' >
<tr>
<td style='min-width:250px;'><strong>Primary Administrator</strong></td>
<td>When your business is set up by Lloyds Bank there will be a minimum of two super user administrator profiles (known as primary administrators). These super users can add users and user role profiles, including additional administrators, in line with business requirements.</td>
</tr>
<tr>
<td><strong>Administrator</strong></td>
<td>Administrators can be assigned to multiple or individual entities within a company structure and have the ability to create and approve changes to users and user role profiles.</td>
</tr>
<tr>
<td><strong>Approval Chain</strong></td>
<td>This allows you to select the order in which users or Approval Groups will need to approve a payment.  If an Approval group is added to the Approval chain twice, it means two users from the group must approve the payment.  All the Approvers you set up under an Approval chain must approve the payment.</td>
</tr>
<tr>
<td><strong>Approval Group</strong></td>
<td>Instead of selecting an individual user, a group of users can be selected within which “any” is able to approve a payment sent to the approval group. If one user is in two groups, they can only approve for one group and another user needs to approve for the second group.</td>
</tr>
<tr>
<td><strong>Approval Level</strong></td>
<td>This allows you to differentiate by payment amount for example the level 1 approval chain may be all payments up to £10,000, the level 2 approval chain could be payments from £10,001 upwards.</td>
</tr>
<tr>
<td><strong>Hierarchy Group</strong></td>
<td>Comprised of users within an entity who are given certain permissions.</td>
</tr>
<tr>
<td><strong>Inter-account</strong></td>
<td>An instruction to move money between accounts held by you (or by the same legal entity).</td>
</tr>
<tr>
<td><strong>Legal Entity Identifier (LEI)</strong></td>
<td>A 20-character alphanumeric code. It is a global standard designed to uniquely identify any legally distinct entity which engages in financial transactions.</td>
</tr>
<tr>
<td><strong>Lloyds Bank</strong></td>
<td>Refers to Lloyds Bank plc.</td>
</tr>
<tr>
<td><strong>Payment purpose code (PPC)</strong></td>
<td>A four-character alphanumeric code which can be added to a payment instruction then carried across the payment chain, providing information to all users.</td>
</tr>
<tr>
<td><strong>User</strong></td>
<td>Individual company employees with access to the Lloyds Bank Gem Connect platform. A user role profile is assigned to ensure they have the right access and functionality available to them.</td>
</tr>
<tr>
<td><strong>User role profile</strong></td>
<td>A user role profile will dictate what the user can do within the relevant domain they have been set up in.  A user role profile must be set up before the user is created.</td>
</tr>
</tbody></table>`


// WEBPACK FOOTER //
// ./src/components/content/glossary.ts